import React, { createContext, useState, useContext } from 'react';

// Create the context
const DemoContext = createContext();

// Create a provider component
export function DemoProvider({ children }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [manualAnswers, setManualAnswers] = useState({});
  const [manualAnalysisTime, setManualAnalysisTime] = useState(0);
  const [analysisCompleted, setAnalysisCompleted] = useState(false);

  // Function to reset all state
  const resetDemo = () => {
    setSelectedFile(null);
    setManualAnswers({});
    setManualAnalysisTime(0);
    setAnalysisCompleted(false);
  };

  // Function to update selected file only
  const setSelectedFileOnly = (file) => {
    setSelectedFile(file);
  };

  // Function to update manual analysis results
  const setManualAnalysisResults = (file, answers, time) => {
    if (file) setSelectedFile(file);
    if (answers) setManualAnswers(answers);
    if (time || time === 0) setManualAnalysisTime(time);
  };

  // Function to mark AI analysis as completed
  const completeAIAnalysis = () => {
    setAnalysisCompleted(true);
  };

  // Value object that will be passed to consumers
  const value = {
    selectedFile,
    manualAnswers,
    manualAnalysisTime,
    analysisCompleted,
    resetDemo,
    setSelectedFileOnly,
    setManualAnalysisResults,
    completeAIAnalysis
  };

  return <DemoContext.Provider value={value}>{children}</DemoContext.Provider>;
}

// Custom hook to use the demo context
export function useDemoContext() {
  const context = useContext(DemoContext);
  if (context === undefined) {
    throw new Error('useDemoContext must be used within a DemoProvider');
  }
  return context;
}
